// İSG Portal — web platform depolama adaptörleri (idb + localStorage).
//
// SADECE web app'leri (web-expert / web-supplier) tarafından import edilir; mobil
// kendi `expo-secure-store` adaptörünü enjekte eder. Web barrel (`index.ts`)
// bunları dışa açar, app giriş noktası `configureAuthStorage` /
// `configureCultureStorage` ile enjekte eder.
//
// Auth token'ları IndexedDB'de (idb) tutulur; refresh token hassastır, XSS
// yüzeyini küçültmek için erişim yalnız auth store üzerindendir (global/pencere
// değişkeni yok). Prod'da httpOnly cookie'ye geçiş bir sonraki güvenlik turudur.

import { openDB } from 'idb';
import type { KVStorage } from './storage';

const DB_NAME = 'isgportal-auth';
const STORE_NAME = 'kv';
const DB_VERSION = 1;

const dbPromise =
  typeof indexedDB !== 'undefined'
    ? openDB(DB_NAME, DB_VERSION, {
        upgrade(db) {
          if (!db.objectStoreNames.contains(STORE_NAME)) {
            db.createObjectStore(STORE_NAME);
          }
        },
      })
    : null;

/** IndexedDB destekli auth token depolaması (web). */
export const webIdbAuthStorage: KVStorage = {
  async getItem(name) {
    if (!dbPromise) return null;
    return (await (await dbPromise).get(STORE_NAME, name)) ?? null;
  },
  async setItem(name, value) {
    if (!dbPromise) return;
    await (await dbPromise).put(STORE_NAME, value, name);
  },
  async removeItem(name) {
    if (!dbPromise) return;
    await (await dbPromise).delete(STORE_NAME, name);
  },
};

/** localStorage destekli dil tercihi depolaması (web). */
export const webLocalCultureStorage: KVStorage = {
  getItem(name) {
    try {
      return typeof localStorage !== 'undefined' ? localStorage.getItem(name) : null;
    } catch {
      return null;
    }
  },
  setItem(name, value) {
    try {
      if (typeof localStorage !== 'undefined') {
        localStorage.setItem(name, value);
      }
    } catch {
      // Depolama kapalıysa (özel mod) sessiz geç — oturumluk dil yine çalışır.
    }
  },
  removeItem(name) {
    try {
      if (typeof localStorage !== 'undefined') {
        localStorage.removeItem(name);
      }
    } catch {
      // yok say
    }
  },
};
